<template>
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path
      d="M12 17q.4 0 .7-.3t.3-.7v-4l-.3-.7-.7-.3-.7.3-.3.7v4q0 .4.3.7t.7.3m0-8q.4 0 .7-.3T13 8l-.3-.7L12 7l-.7.3-.3.7q0 .4.3.7t.7.3m0 13a10 10 0 0 1-7-3A10 10 0 0 1 2.7 8.2 10 10 0 0 1 8 2.8Q9.9 2 12 2a10 10 0 0 1 7 3 10 10 0 0 1 3 7 10 10 0 0 1-3 7 10 10 0 0 1-7 3"
    />
  </svg>
</template>
